var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QualifyInfoRow = exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../../elements/Basic");

var _ColorHelper = require("../Utils/ColorHelper");

var _i18n = _interopRequireDefault(require("../../../../i18n"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Table/QualifyInfo/QualifyInfo.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function getEuropaLeagueTranslationKey(qualifyInfo) {
  if (qualifyInfo.qualifyType === 'Group') {
    return 'standings_qualify.europa_league';
  } else if (qualifyInfo.method === 'Play_Off') {
    return 'standings_qualify.europa_league_play_offs';
  }

  return 'standings_qualify.europa_league_quali';
}

function getRelegationTranslationKey(method) {
  switch (method) {
    case 'Playoff_Relegation':
      return 'standings_qualify.way_down_relegation';

    case 'Play_Off':
      return 'standings_qualify.way_down_play_offs';

    default:
      return 'standings_qualify.way_down';
  }
}

function getPromotionTranslationKey(method) {
  switch (method) {
    case 'Playoff_Promotion':
      return 'standings_qualify.promotion_relegation';

    case 'Play_Off':
      return 'standings_qualify.promotion_play_offs';

    default:
      return 'standings_qualify.promotion';
  }
}

function getQualifyName(qualifyInfo) {
  if (!qualifyInfo) {
    return '';
  }

  switch (qualifyInfo.qualify) {
    case 'Champions_League':
      return (0, _i18n.default)('standings_qualify.champions_league');

    case 'Champions_League_Qualifying':
      return (0, _i18n.default)('standings_qualify.champions_league_quali');

    case 'Europa_Cup':
      return (0, _i18n.default)(getEuropaLeagueTranslationKey(qualifyInfo));

    case 'Relegation':
      return (0, _i18n.default)(getRelegationTranslationKey(qualifyInfo.method));

    case 'Promotion':
      return (0, _i18n.default)(getPromotionTranslationKey(qualifyInfo.method));

    default:
      return '';
  }
}

var QualifyInfo = function (_React$Component) {
  (0, _inherits2.default)(QualifyInfo, _React$Component);

  var _super = _createSuper(QualifyInfo);

  function QualifyInfo() {
    (0, _classCallCheck2.default)(this, QualifyInfo);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(QualifyInfo, [{
    key: "render",
    value: function render() {
      var qualifyInfos = this.props.qualifyInfos;
      if (!qualifyInfos) return null;
      var uniqueInfos = [];
      return qualifyInfos.map(function (info) {
        if (uniqueInfos.indexOf(getQualifyName(info)) === -1) {
          uniqueInfos.push(getQualifyName(info));
          return _react.default.createElement(QualifyInfoRow, {
            key: getQualifyName(info),
            qualifyInfo: info,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 73,
              columnNumber: 24
            }
          });
        }

        return null;
      });
    }
  }]);
  return QualifyInfo;
}(_react.default.Component);

QualifyInfo.propTypes = {
  qualifyInfos: _propTypes.default.oneOfType([_propTypes.default.arrayOf(Object), _propTypes.default.object])
};
var _default = QualifyInfo;
exports.default = _default;

var QualifyInfoRow = function QualifyInfoRow(_ref) {
  var qualifyInfo = _ref.qualifyInfo;
  return _react.default.createElement(_Basic.View, {
    isFlex: true,
    row: true,
    centerHorizontal: true,
    mb: 2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 5
    }
  }, _react.default.createElement(_Basic.View, {
    bg: (0, _ColorHelper.getBackgroundColorOfQualifier)(qualifyInfo),
    width: 8,
    height: 8,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 9
    }
  }), _react.default.createElement(_Basic.Text, {
    pl: 2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 9
    }
  }, getQualifyName(qualifyInfo)));
};

exports.QualifyInfoRow = QualifyInfoRow;